export function textComparator(a: string, b: string): number {
  return (`${a}`).localeCompare(`${b}`);
}
